// Store accepted promotions in localStorage to persist across page reloads
const ACCEPTED_PROMOTIONS_KEY = 'acceptedPromotions';
const acceptedPromotions = new Set(JSON.parse(localStorage.getItem(ACCEPTED_PROMOTIONS_KEY) || '[]'));
import { loggedIn } from "//bark.co/cdn/shop/t/282/assets/utils.js?v=48097076372142184661783451415";

// Check for previously accepted promotions on page load and reorder cards
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.partner-promotion-card__accept-offer-button').forEach(button => {
    const promotionKey = button.dataset.uniqueKey;
    if (acceptedPromotions.has(promotionKey) && loggedIn()) {
      hideButtonShowSuccess(button);
    }
  });

  // Reorder cards to show non-accepted promotions first
  reorderPromotionCards();
});

function reorderPromotionCards() {
  const grid = document.querySelector('.partner-promotions__grid');
  if (!grid) return;

  const cards = Array.from(grid.querySelectorAll('.partner-promotion-card'));
  const nonAcceptedCards = [];
  const acceptedCards = [];

  // Separate cards into accepted and non-accepted
  cards.forEach(card => {
    const button = card.querySelector('.partner-promotion-card__accept-offer-button');
    const promotionKey = button?.dataset.uniqueKey;

    if (promotionKey && acceptedPromotions.has(promotionKey)) {
      acceptedCards.push(card);
    } else {
      nonAcceptedCards.push(card);
    }
  });

  // Clear the grid and re-add cards in the desired order
  grid.innerHTML = '';
  nonAcceptedCards.forEach(card => grid.appendChild(card));
  acceptedCards.forEach(card => grid.appendChild(card));
}

function handlePromotionAccept(button) {
  const data = button.dataset || {};
  const { uniqueKey, source, title, description, offerSummary, value, partnerName, couponValue, couponCode } = data;

  const container = document.querySelector('.partner-promotions__container');
  const { customerEmail } = container?.dataset || {};

  const eventData = {
    unique_key: uniqueKey,
    source: source,
    title: title,
    description: description,
    offer_summary: offerSummary,
    value: value,
    partner_name: partnerName,
    coupon_value: couponValue,
    coupon_code: couponCode,
    user: { email: customerEmail }
  };

  // First check if already accepted
  if (acceptedPromotions.has(uniqueKey)) {
    return;
  }

  // Publish the event
  if (window.Shopify && window.Shopify.analytics) {
    window.Shopify.analytics.publish('rudderstack_track', {
      eventName: 'Partner Offer Accepted',
      eventData: eventData
    });
  }

  // Add to accepted promotions
  acceptedPromotions.add(uniqueKey);
  localStorage.setItem(ACCEPTED_PROMOTIONS_KEY, JSON.stringify([...acceptedPromotions]));

  // Update UI
  hideButtonShowSuccess(button);
}

function hideButtonShowSuccess(button) {
  if (!loggedIn()) {
    return;
  }

  // Hide the button
  button.style.display = 'none';

  // Show success message
  const card = button.closest('.partner-promotion-card');
  const successMessage = card.querySelector('.partner-promotion-card__success-message');
  successMessage.classList.add('partner-promotion-card__success-message--visible');

  // Replace value badge with claimed badge
  const valueBadge = card.querySelector('.partner-promotion-card__value-badge');
  if (valueBadge) {
    valueBadge.classList.remove('partner-promotion-card__value-badge');
    valueBadge.classList.add('partner-promotion-card__claimed-badge');
    valueBadge.querySelector('span').textContent = 'Claimed';
  }
}

function openTermsModal(promotionKey) {
  // Close any open modals first
  document.querySelectorAll('.terms-modal').forEach(modal => {
    modal.classList.remove('terms-modal--open');
  });

  // Open the selected modal
  const modalId = `terms-modal-${promotionKey}`;
  const modal = document.getElementById(modalId);

  if (!modal) {
    console.error('Modal not found with ID:', modalId);
    return;
  }

  modal.classList.add('terms-modal--open');
  document.body.style.overflow = 'hidden';

  // Track terms modal opened
  if (window.Shopify && window.Shopify.analytics) {
    window.Shopify.analytics.publish('rudderstack_track', {
      eventName: 'Partner Promotion Terms Viewed',
      eventData: {
        unique_key: promotionKey,
      }
    });
  }
}

function closeTermsModal(promotionKey) {
  const modal = document.getElementById(`terms-modal-${promotionKey}`);
  modal.classList.remove('terms-modal--open');
  document.body.style.overflow = 'auto';
}

// Make functions globally available for inline onclick handlers
window.handlePromotionAccept = handlePromotionAccept;
window.openTermsModal = openTermsModal;
window.closeTermsModal = closeTermsModal;

// Close modal when clicking outside - set up after DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.terms-modal').forEach(modal => {
    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.classList.remove('terms-modal--open');
        document.body.style.overflow = 'auto';
      }
    });
  });
});
